import { render, staticRenderFns } from "./DetailEmployeeComponent.vue?vue&type=template&id=a6534662&scoped=true"
import script from "./DetailEmployeeComponent.vue?vue&type=script&lang=js"
export * from "./DetailEmployeeComponent.vue?vue&type=script&lang=js"
import style0 from "./DetailEmployeeComponent.vue?vue&type=style&index=0&id=a6534662&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6534662",
  null
  
)

export default component.exports